import { FORM_METHOD_TYPES } from "../../../../stateCommon/consts";
import { getGetDeleteParams, getObjectJSONString, pickPostDataCodeString } from "../../../utils/code";
import { getEntityPrimaryKey } from "../../../../stateCommon/getEntityPrimaryKey";
import { METHOD_TEMPLATES } from "../../../utils/consts";
import { getCgiDefaultParamsValue } from "../../../../common/schemaUtil";
export const create = options => {
  const {
    collection
  } = options;
  const isHttp = collection.type === 'http';
  let code = `{
  body:args.postData,
  ${pickPostDataCodeString}
}
  `.trim();
  if (isHttp) {
    const {
      query
    } = getCgiDefaultParamsValue(collection, 'create');
    code = `
{
  query:${getObjectJSONString(query)},
  body:args.postData,
  ${pickPostDataCodeString}
}
`;
  }
  const info = {
    args: [{
      id: 'postData',
      title: '提交的数据项',
      'ds:systemArg': true
    }],
    type: FORM_METHOD_TYPES.request,
    tpl: METHOD_TEMPLATES.list.create,
    cgi: 'create',
    params: {
      request: code
    }
  };
  return info;
};
export const update = options => {
  const {
    collection,
    isHttp
  } = options;
  const key = getEntityPrimaryKey(collection) || (isHttp ? 'id' : '_id');
  let code = `{
  query:{
    id:args.postData['${key}']
  },
  body:args.postData,
  ${pickPostDataCodeString}
}
`;
  if (isHttp) {
    const {
      query
    } = getCgiDefaultParamsValue(collection, 'update');
    code = `{
  query:${getObjectJSONString(query)},
  body:args.postData, 
  ${pickPostDataCodeString}
}
`;
  }
  const info = {
    args: [{
      id: 'postData',
      title: '提交的数据项',
      'ds:systemArg': true
    }],
    type: FORM_METHOD_TYPES.request,
    tpl: METHOD_TEMPLATES.list.update,
    cgi: 'update',
    params: {
      request: code.trim()
    }
  };
  return info;
};
export const get = options => {
  const params = getGetDeleteParams(options, 'args.id');
  const info = {
    args: [{
      id: 'id',
      title: '主键值',
      'ds:systemArg': true
    }],
    type: FORM_METHOD_TYPES.request,
    tpl: METHOD_TEMPLATES.list.get,
    cgi: 'get',
    params: {
      request: params.trim()
    }
  };
  return info;
};
export const deleteConfig = options => {
  const {
    collection,
    isHttp
  } = options;
  const key = getEntityPrimaryKey(collection) || (isHttp ? 'id' : '_id');
  const params = getGetDeleteParams(options, `args.postData['${key}']`);
  const info = {
    args: [{
      id: 'postData',
      title: '需要删除的数据项',
      'ds:systemArg': true
    }],
    type: FORM_METHOD_TYPES.request,
    tpl: METHOD_TEMPLATES.list.delete,
    cgi: 'delete',
    params: {
      request: params.trim()
    }
  };
  return info;
};
//# sourceMappingURL=crud.js.map
